import { Dialog } from "primereact/dialog";
import CustomeButton from "~/components/Button";
import PropTypes from "prop-types";
import logo from "../../../../assets/images/confirm.png";

const ShareholderRegistrationSuccessModal = ({
  visible,
  closeModal,
  shareholderName,
  shareholderType,
}) => {
  return (
    <Dialog
      visible={visible}
      className="transaction-modal"
      onHide={closeModal}
      header={null}
      modal
      style={{ height: "80%" }}
    >
      <div className="transaction-modal-container align-items-center justify-content-center p-4 h-full">
        <div className="flex flex-column gap-2 align-items-center justify-content-center">
          <div className="success-icon-container mb-4">
            <img
              src={logo}
              alt="Success"
              width="120"
              height="120"
              className="border-round-lg"
            />
          </div>

          <div className="content-header flex flex-column gap-2 mb-2">
            <p className="title font-bold text-xl m-0">
              Shareholder Transaction Registered
            </p>
          </div>

          <p className="text-lg text-gray-600 mb-4 m-0">
            {shareholderName} is now officially{" "}
            {shareholderType === "Individual" ? "an" : "a"} {shareholderType}{" "}
            Shareholder
          </p>
          <CustomeButton label="Close Wizard" onClick={closeModal} />
        </div>
      </div>
    </Dialog>
  );
};

ShareholderRegistrationSuccessModal.propTypes = {
  visible: PropTypes.bool,
  closeModal: PropTypes.func,
  shareholderName: PropTypes.string,
  shareholderType: PropTypes.string,
};

export default ShareholderRegistrationSuccessModal;
